module.exports = __webpack_public_path__ + "img/12.e071930a.svg";